
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engineer/ai-es-builder/[id]",
      function () {
        return require("private-next-pages/engineer/ai-es-builder/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engineer/ai-es-builder/[id]"])
      });
    }
  